import { useEffect, useState } from 'react';
import { ColorValidator } from '../../../utils/contrastCheck';

const colorValidator = new ColorValidator();

const useDominantColor = (imageUrl: string | undefined): string | undefined => {
  const [dominantColor, setDominantColor] = useState<string>();

  useEffect(() => {
    let cancelled = false;

    if (!imageUrl) {
      setDominantColor(undefined);
      return;
    }

    colorValidator
      .extractDominantColorFromImage(imageUrl)
      .then((color) => {
        if (!cancelled) setDominantColor(color);
      })
      .catch(() => {
        if (!cancelled) setDominantColor(undefined);
      });

    return () => {
      cancelled = true;
    };
  }, [imageUrl]);

  return dominantColor;
};

export default useDominantColor;
